import SurveyResults from './suveyResults'

const SurveyResultsService = new SurveyResults()

const getSurveysProgress = (surveyIds: string[]) =>
  SurveyResultsService.surveysProgress(surveyIds)

const getSurveysProgressLegacy = (
  surveyIds: string[],
  extraConfig?: Record<string, unknown>
) => SurveyResultsService.surveysProgressLegacy(surveyIds, extraConfig)

export { getSurveysProgress, getSurveysProgressLegacy }
